/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".swiper-pagination-catalog[_ngcontent-%COMP%]{margin-top:24px}.catalog-slider-background[_ngcontent-%COMP%]{position:absolute;height:364px;min-height:364px;top:0;left:0;right:0}@media (min-width:992px){.catalog-slider-background[_ngcontent-%COMP%]{height:312px;min-height:312px}}"];
export { styles as styles };
